<template>
  <div v-if="warranty">
    <b-row>
      <!-- Left: THÔNG TIN DỊCH VỤ -->
      <b-col md="9" class="mb-3">
        <h6 class="font-weight-bold mb-3">THÔNG TIN DỊCH VỤ</h6>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Số phiếu</label>
              <b-form-input
                size="sm"
                :value="warranty.code"
                readonly
                class="font-weight-bold"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Loại dịch vụ</label>
              <b-form-select
                size="sm"
                class="select-style"
                :value="warranty.warrantyServiceId"
                :options="warrantyServiceOptions"
                value-field="id"
                text-field="name"
                :disabled="isEditMode && !canUpdateServiceType"
                @input="updateField('warrantyServiceId', $event)"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null"
                    >--Chọn loại dịch vụ--</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Khách hàng</label>
              <b-form-input
                size="sm"
                :value="warranty.customerName"
                readonly
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Địa chỉ</label>
              <b-form-input
                size="sm"
                :value="warranty.customerAddress || warranty.customerPhone"
                @input="updateField('customerAddress', $event)"
                placeholder="Nhập địa chỉ"
              ></b-form-input>
            </b-form-group>

            <ImeiSearch
              :value="warranty.imeiCode"
              @input="updateField('imeiCode', $event)"
              @imei-selected="onImeiSelected"
              :is-edit-mode="isEditMode"
              label="IMEI/Serial"
              placeholder="Nhập IMEI/Serial để tìm kiếm"
            />
          </b-col>

          <!-- Middle Column: Status & Details -->
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Trạng thái</label>
              <b-form-select
                size="sm"
                :options="statusOptions"
                value-field="key"
                text-field="value"
                :value="warranty.status"
                @input="updateField('status', $event)"
              >
                <template v-slot:first>
                  <b-form-select-option :value="null"
                    >--Chọn trạng thái--</b-form-select-option
                  >
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Kĩ thuật viên kiểm tra</label>
              <EmployeeSearch
                :value="inspectedByEmployeeName"
                :employee-id="warranty.inspectedByEmployeeId"
                placeholder="Tên hoặc mã nhân viên"
                @employee-selected="onInspectedByEmployeeSelected"
              />
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Họ tên</label>
              <b-form-input
                size="sm"
                :value="warranty.customerName"
                readonly
              ></b-form-input>
            </b-form-group>

            <CustomerPhoneSearch
              :value="warranty.customerPhone"
              @input="updateField('customerPhone', $event)"
              @customer-found="onCustomerFound"
              @customer-cleared="onCustomerCleared"
              label="Số điện thoại"
              placeholder="Nhập số điện thoại"
            />

            <b-form-group>
              <label class="font-weight-bold">Tên hàng</label>
              <div class="d-flex align-items-center">
                <b-form-input
                  size="sm"
                  :value="warranty.productName"
                  readonly
                  class="flex-grow-1"
                ></b-form-input>
              </div>
            </b-form-group>
          </b-col>

          <!-- Right Column: Financial & Purchase Details -->
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Báo giá</label>
              <BInputNumber
                :value="warranty.estimatedCost"
                @valueChange="updateField('estimatedCost', $event)"
                placeholder="Nhập báo giá"
                size="sm"
              />
            </b-form-group>

            <b-form-group class="invisible">
              <label class="font-weight-bold">Tiền thu khách</label>
              <BInputNumber
                :value="warranty.actualCost"
                @valueChange="updateField('actualCost', $event)"
                placeholder="Nhập tiền thu khách"
                size="sm"
              />
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Email</label>
              <b-form-input
                size="sm"
                type="email"
                :value="warranty.customerEmail"
                @input="updateField('customerEmail', $event)"
                placeholder="Nhập email"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Số liên lạc</label>
              <b-form-input
                size="sm"
                :value="warranty.customerContactNumber"
                @input="updateField('customerContactNumber', $event)"
                placeholder="Nhập số liên lạc"
              ></b-form-input>
            </b-form-group>

            <b-form-group>
              <label class="font-weight-bold">Số lần quay lại</label>
              <b-form-input
                size="sm"
                :value="warranty.returnCount || ''"
                disabled
                type="number"
                min="0"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
      <b-row>
        <b-col cols="12" class="mb-4">
          <WarrantyPackageInfoCard
            :warranty-product="warranty.warrantyProduct || {}"
            :purchase-date="warranty.purchaseDate"
            :visible="
              !!(
                warranty.imeiCode &&
                warranty.warrantyProduct?.id
              )
            "
            @dismiss="onClearWarrantyPackage"
          />
        </b-col>
       </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group>
              <label class="font-weight-bold">Kèm theo</label>
              <div class="d-flex flex-wrap">
                <b-form-checkbox
                  v-for="equipment in accompanyingEquipments"
                  :key="equipment.id"
                  :checked="
                    warranty.accompanyingItems &&
                    warranty.accompanyingItems.includes(equipment.id)
                  "
                  @change="toggleAccompanyingItem(equipment.id, $event)"
                  :disabled="!equipment.isActive"
                  class="mr-3 mb-2"
                >
                  {{ equipment.name }}
                </b-form-checkbox>
              </div>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Hình ảnh</label>
              <div class="d-flex align-items-center">
                <span
                  class="mr-2 text-primary"
                  type="button"
                  @click="showUploadModal = true"
                  >{{ warranty.attachmentCount || 0 }} files</span
                >
                <b-button
                  v-if="isEditMode && warranty.id"
                  size="sm"
                  variant="outline-primary"
                  class="mr-2"
                  @click="showUploadModal = true"
                >
                  <i class="fa fa-upload"></i>
                </b-button>
              </div> </b-form-group
          ></b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Ngày mua</label>
              <date-picker
                placeholder="Chọn ngày mua"
                class="form-control form-control-sm"
                :config="dpConfigs.date"
                :value="warranty.purchaseDate"
                @input="updateField('purchaseDate', $event)"
              ></date-picker> </b-form-group
          ></b-col>
        </b-row>
        <b-row>
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Mô tả</label>
              <b-form-textarea
                :value="warranty.issueDescription"
                @input="updateField('issueDescription', $event)"
                placeholder="Nhập mô tả lỗi"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Ngoại quan</label>
              <b-form-textarea
                :value="warranty.externalNote"
                @input="updateField('externalNote', $event)"
                placeholder="Nhập ghi chú ngoại quan"
              ></b-form-textarea> </b-form-group
          ></b-col>
              <b-col cols="4">
            <b-form-group>
              <label class="font-weight-bold">Ghi chú nội bộ</label>
              <b-form-textarea
                :value="warranty.internalNote"
                @input="updateField('internalNote', $event)"
                placeholder="Nhập ghi chú nội bộ"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
      <!-- Right: Thanh toán -->
      <b-col md="3" class="mb-3">
        <div class="warranty-payment-box p-3">
          <p class="text-dark font-size-h5 font-weight-bold mb-3">Thanh toán</p>
          <b-row class="mb-2">
            <b-col cols="6">
              <b class="textTitlePayment text-warning">Tổng tiền xuất linh kiện:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment">{{
                convertPrice(replaceProductsTotalAmount)
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2" v-if="replaceProductsTotalDiscountAmount">
            <b-col cols="6">
              <b class="textTitlePayment text-danger">Tổng chiết khấu:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment">{{
                convertPrice(replaceProductsTotalDiscountAmount)
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <b class="textTitlePayment">Tổng tiền sửa chữa:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment">{{
                convertPrice(totalRepairCostSum)
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <b class="textTitlePayment font-weight-bold">Tổng chi phí:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment font-weight-bold">{{
                convertPrice(totalPaymentAmount)
              }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-2 align-items-center">
            <b-col cols="12">
              <b class="textTitlePayment text-success">Phí hỗ trợ bảo hành:</b>
            </b-col>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-input-group>
                <BInputNumber
                  :value="warranty.supportCost"
                  @valueChange="updateField('supportCost', $event)"
                  placeholder="0"
                  size="sm"
                  inputClass="font-weight-bold text-success"
                />
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <b class="textTitlePayment text-primary">Tiền thu khách:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment font-weight-bold text-primary">
                {{ convertPrice(warranty.actualCost || 0) }}
              </span>
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col cols="6">
              <b class="textTitlePayment font-weight-bold">Tiền đã cọc:</b>
            </b-col>
            <b-col cols="6" class="text-right">
              <span class="textPayment font-weight-bold">{{
                convertPrice(warranty.depositAmount)
              }}</span>
            </b-col>
          </b-row>
          <BillPayment
            ref="bill-payment"
            :finalAmount="warranty.actualCost - warranty.depositAmount"
            :billData="warrantyBillData"
            :onSubmiting="false"
            :disabled="false"
            :isAllowQRCode="false"
            :showDeposit="true"
            @receive-payment="onUpdatePayment"
            @receive-payment-mul="onUpdatePaymentMul"
          />
        </div>
      </b-col>
    </b-row>

    <!-- Repair section moved to WarrantyRepairSection.vue -->

    <!-- Upload File Modal -->
    <b-modal
      v-if="isEditMode && warranty.id"
      v-model="showUploadModal"
      title="Upload hình ảnh"
      hide-footer
      size="lg"
    >
      <upload-file
        :model-id="warranty.id"
        :model-name="'warranties'"
        :max-files="10"
        :max-file-size="5 * 1024 * 1024"
      />
    </b-modal>
  </div>
</template>

<script>
import EmployeeSearch from '@/view/components/common/EmployeeSearch.vue';
import UploadFile from '@/view/modules/upload-v2/Upload.vue';
import CustomerPhoneSearch from './CustomerPhoneSearch.vue';
import ImeiSearch from './ImeiSearch.vue';
import timeUtils from '@/utils/date';
import { currencyMask, convertPrice, cloneDeep, unMaskPrice, catchNum } from '@/utils/common';
import { checkWarrantyByImei, calculateActualCost } from '../utils/warrantyApi';
import { WARRANTY_RECEPTION_STATUS_NAME } from '@/utils/enum-name';
import { PAYMENT_TYPE } from '@/utils/enum';
import BInputNumber from '@/view/base/bootstrap/BInputNumber.vue';
import BillPayment from '@/view/components/bills/BillPayment.vue';
import WarrantyPackageInfoCard from './WarrantyPackageInfoCard.vue';
const defaultPaymentInfo = {
  cashAmount: 0,
  cashAccountantName: '',
  cashAccountId: null,
  transferAmount: 0,
  transferAccountantName: '',
  transferAccountantId: null,
  creditAmount: 0,
  creditAccountantName: '',
  creditAccountantId: null,
  creditCardFee: 0,
  creditFeeAccountantId: null,
  payCreditFeeType: 1,
  installedMoneyAmount: 0,
  installMoneyAccountId: null,
  refundAmount: 0,
  refundAccountId: null,
};

export default {
  name: 'WarrantyDispatchSection',
  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    warrantyServiceOptions: {
      type: Array,
      default: () => [],
    },
    accompanyingEquipments: {
      type: Array,
      default: () => [],
    },
    optionStores: {
      type: Array,
      default: () => [],
    },
    inspectedByEmployeeName: {
      type: String,
      default: '',
    },
    warrantyRepairs: {
      type: Array,
      default: () => [{}],
    },
    solutionOptions: {
      type: Array,
      default: () => [],
    },
    severityLevelOptions: {
      type: Array,
      default: () => [],
    },
    errorGroupOptions: {
      type: Array,
      default: () => [],
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    canUpdateServiceType: {
      type: Boolean,
      default: false,
    },
    disableReplaceExportButton: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    EmployeeSearch,
    UploadFile,
    CustomerPhoneSearch,
    ImeiSearch,
    BInputNumber,
    BillPayment,
    WarrantyPackageInfoCard,
  },
  data() {
    return {
      WARRANTY_RECEPTION_STATUS_NAME,
      mask: currencyMask,
      dpConfigs: {
        date: timeUtils.DP_CONFIG.date,
        datetime: timeUtils.DP_CONFIG_DATETIME.date,
      },
      showUploadModal: false,
      showReplaceProducts: false,
    };
  },
  watch: {
    'warranty.id'(newId, oldId) {
      if (newId === oldId) return;
    },
    warrantyRepairs: {
      deep: true,
      handler() {
        this.scheduleRefreshActualCost();
      },
    },
    'warranty.supportCost'(val, old) {
      if (val === old) return;
      this.scheduleRefreshActualCost();
    },
  },
  computed: {
    warranty() {
      return this.value;
    },
    statusOptions() {
      return Object.entries(WARRANTY_RECEPTION_STATUS_NAME).map(
        ([key, value]) => ({
          key,
          value,
        }),
      );
    },
    replaceProductsList() {
      const list = this.warranty.replaceProducts;
      return Array.isArray(list) ? list : [];
    },
    replaceProductsCount() {
      return this.replaceProductsList.length;
    },
    replaceProductsTotalAmount() {
      const list = this.replaceProductsList;
      return list.reduce(
        (sum, item) => sum + (Number(item.totalAmount) || 0),
        0,
      );
    },
    replaceProductsTotalDiscountAmount() {
      const list = this.replaceProductsList;
      return list.reduce(
        (sum, item) => sum + (Number(item.discountAmount) || 0),
        0,
      );
    },
    totalRepairCostSum() {
      return (this.warrantyRepairs || []).reduce((sum, { repairCost }) => {
        const _repairCost = catchNum(unMaskPrice(repairCost) || 0);
        return sum + _repairCost;
      }, 0);
    },
    totalPaymentAmount() {
      const parts = Number(this.replaceProductsTotalAmount) || 0;
      const repair = Number(this.totalRepairCostSum) || 0;
      return parts + repair;
    },
    warrantyBillData() {
      return {
        id: this.warranty.id,
        storeId: this.warranty.storeId,
        customerId: this.warranty.customerId,
        customerName: this.warranty.customerName,
        customerMobile: this.warranty.customerPhone,
        paymentInfo: this.warranty.paymentInfo
          ? { ...defaultPaymentInfo, ...this.warranty.paymentInfo }
          : cloneDeep(defaultPaymentInfo),
        installments: this.warranty.installments || [],
        credits: this.warranty.credits || [],
        transfer: this.warranty.transfer || [],
        cash: this.warranty.cash || [],
        refunds: this.warranty.refunds || [],
        deposit: this.warranty.deposit || [],
      };
    },
  },
  methods: {
    convertPrice,
    scheduleRefreshActualCost() {
      clearTimeout(this._refreshTimer);
      this._refreshTimer = setTimeout(() => this.refreshActualCost(), 600);
    },
    async refreshActualCost() {
      if (!this.warranty.id) return;
      const result = await calculateActualCost(this.warranty.id, {
        warrantyRepairs: this.warrantyRepairs,
        supportCost: this.warranty.supportCost,
      });
      if (result) {
        this.updateField('actualCost', result.actualCost);
      }
    },
    onUpdatePayment(paymentInfo) {
      this.$emit('input', {
        ...this.warranty,
        paymentInfo: cloneDeep(paymentInfo),
      });
    },
    onUpdatePaymentMul(items, type) {
      const key =
        type === PAYMENT_TYPE.INSTALLMENT
          ? 'installments'
          : type === PAYMENT_TYPE.CREDIT
          ? 'credits'
          : type === PAYMENT_TYPE.TRANSFER
          ? 'transfer'
          : type === PAYMENT_TYPE.CASH
          ? 'cash'
          : type === PAYMENT_TYPE.REFUND
          ? 'refunds'
          : type === PAYMENT_TYPE.DEPOSIT
          ? 'deposit'
          : null;
      if (!key) return;
      this.$emit('input', {
        ...this.warranty,
        [key]: cloneDeep(items || []),
      });
    },
    updateField(field, value) {
      if (this.warranty[field] === value) return;

      const updatedWarranty = { ...this.warranty, [field]: value };
      this.$emit('input', updatedWarranty);
    },
    toggleAccompanyingItem(equipmentId, checked) {
      const currentItems = this.warranty.accompanyingItems || [];
      let updatedItems;
      if (checked) {
        updatedItems = [...currentItems, equipmentId];
      } else {
        updatedItems = currentItems.filter((id) => id !== equipmentId);
      }
      this.updateField('accompanyingItems', updatedItems);
    },
    onInspectedByEmployeeSelected(employee) {
      const employeeId = employee ? employee.id : null;

      // Emit employee-selected event first
      this.$emit('employee-selected', employee);

      // Only emit input if value actually changed
      if (this.warranty.inspectedByEmployeeId === employeeId) return;

      this.$emit('input', {
        ...this.warranty,
        inspectedByEmployeeId: employeeId,
      });
    },
    onCustomerFound(customerData) {
      const updates = {};

      // Chỉ update nếu field hiện tại trống
      if (customerData.customerName && !this.warranty.customerName) {
        updates.customerName = customerData.customerName;
      }
      if (customerData.customerEmail && !this.warranty.customerEmail) {
        updates.customerEmail = customerData.customerEmail;
      }
      if (customerData.customerAddress && !this.warranty.customerAddress) {
        updates.customerAddress = customerData.customerAddress;
      }
      if (customerData.customerId && !this.warranty.customerId) {
        updates.customerId = customerData.customerId;
      }

      if (Object.keys(updates).length > 0) {
        const updatedWarranty = { ...this.warranty, ...updates };
        this.$emit('input', updatedWarranty);
      }
    },
    onCustomerCleared() {
      this.updateField('customerName', '');
      this.updateField('customerEmail', '');
      this.updateField('customerAddress', '');
    },
    async onImeiSelected(productData) {
      if (!productData) {
        return;
      }

      const updates = {
        imeiCode: productData.imeiCode || '',
        productName: productData.productName || '',
      };

      if (productData.productId) {
        updates.productId = productData.productId;
      }

      if (this.isEditMode) {
        this.$emit('input', { ...this.warranty, ...updates });
        return;
      }

      try {
        const warrantyInfo = await checkWarrantyByImei(productData.imeiCode);
        if (warrantyInfo) {
          updates.warrantyProduct = warrantyInfo;
          updates.warrantyProductId = warrantyInfo.id;
        } else {
          updates.warrantyProduct = {};
          updates.warrantyProductId = null;
        }
      } catch (e) {
        updates.warrantyProduct = {};
        updates.warrantyProductId = null;
      }

      this.$emit('input', { ...this.warranty, ...updates });
    },
    onClearWarrantyPackage() {
      this.$emit('input', {
        ...this.warranty,
        warrantyProduct: {},
        warrantyProductId: null,
      });
    },
    exportReplaceProducts() {
      if (this.disableReplaceExportButton) return
      const route = this.$router.resolve({
        name: 'add-inventory-dispatch',
        query: {
          storeId: this.warranty.storeId,
          warrantyId: this.warranty.id,
          fromWarranty: true,
          providerId: this.warranty.customerId,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.warranty-payment-box {
  .textPayment {
    font-size: 16px;
    font-weight: 500;
    color: brown;
  }
  .textTitlePayment {
    font-weight: 500;
    font-size: 14px;
  }
}

</style>
